import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faEdit } from '@fortawesome/free-solid-svg-icons';

import { Item, featuredPhoto, photoList } from '_types/item';
import { resizeUrl } from '_utils/image';
import { Description } from "_utils/description";
import { SOL_WEB_URL } from '_utils/config';

import { ImageCarousel } from "../_components/ImageCarousel";

import './ItemEntry.sass';

import guitar from './guitar.svg'

interface ItemEntryHeaderProps {
  item: Item;
  handleClick?: () => void;
}

export const ItemEntryHeader: React.FC<ItemEntryHeaderProps> = ({ item, handleClick }) => {
  const [showCarousel, setShowCarousel] = useState<boolean>(false);

  const featuredUrl = featuredPhoto(item.photos)?.url;

  return (
    <div className='item-header'>
      {showCarousel && <ImageCarousel
          isOpen={showCarousel}
          photos={photoList(item.photos)}
          onClose={() => setShowCarousel(false)}
      />}
      <div className='featured-photo' style={{backgroundColor: '#1c1e27'}}>
        {(featuredUrl &&
          <img src={resizeUrl(featuredUrl, {width: 150, height: 150})} alt='' onClick={() => setShowCarousel(true)} />) ||
          <img src={guitar} alt='' onClick={handleClick} style={{objectFit: 'contain'}} />
        }
      </div>
      <div className='meta' onClick={showCarousel ? undefined : handleClick}>
        <div style={{display: 'flex', flexFlow: 'row nowrap', alignItems: 'center'}}>
          <span><strong>{item.meta.model}</strong> ({item.meta.serialNumber})</span>
          {item.meta.isFeatured && <span className="badge bg-success" style={{color: 'white', marginLeft: '1em'}}>featured</span>}
        </div>
        <span>{new Date(item.meta.productionDate).toLocaleDateString(undefined, {dateStyle: 'medium'})}</span>
      </div>
      <div className='action-buttons visible-on-hover'>
        <div className='preview action-button'>
          <a href={`${SOL_WEB_URL}/item/${item.uuid}`} target="_blank" rel="noopener noreferrer">
            <button className='btn btn-primary'>
              <FontAwesomeIcon icon={faExternalLinkAlt} /> Preview
            </button>
          </a>
        </div>
        <div className='edit action-button'>
          <Link to={`/edit/${item.uuid}`}><button className='btn btn-default'>
            <FontAwesomeIcon icon={faEdit} /> Edit
          </button></Link>
        </div>
      </div>
    </div>
  );
}

export const ItemEntryDetails = ({ description }) => (
  <div className='item-details'>
    <Description xml={description} className="item-description" />
  </div>
)

interface ItemEntryProps {
  item: Item;
}

export const ItemEntry: React.FC<ItemEntryProps> = ({ item }) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return <div className='item'>
    <ItemEntryHeader item={item} handleClick={() => setExpanded(!expanded)} />
    {expanded && <ItemEntryDetails description={item.description} />}
  </div>
};
